/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 04/07/2026.
 */
import { COLOR_PRIMARY } from '../../constants'

type OptionWrapperProps = {
  isSelected: boolean
  body: string
  className?: string
  selectedColor?: string
}

export const OptionWrapper = ({ isSelected, body, className, selectedColor = COLOR_PRIMARY }: OptionWrapperProps) => {
  return (
    <div
      className={className || 'py-2 px-2 me-2 border-1 border rounded-1'}
      style={{
        color: isSelected ? 'white' : 'black',
        background: isSelected ? selectedColor : 'white',
      }}
    >
      <p className="px-1 text-center">{body}</p>
    </div>
  )
}
